module.exports = {
  height: 'height',
  spacing: 'margin, padding',
}
